"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FixedPerDay_1 = __importDefault(require("./billingDeterminants/FixedPerDay"));
var FixedPerMonth_1 = __importDefault(require("./billingDeterminants/FixedPerMonth"));
var BlockedTiersInDays_1 = __importDefault(require("./billingDeterminants/BlockedTiersInDays"));
var BlockedTiersInMonths_1 = __importDefault(require("./billingDeterminants/BlockedTiersInMonths"));
var EnergyTimeOfUse_1 = __importDefault(require("./billingDeterminants/EnergyTimeOfUse"));
var MonthlyDemand_1 = __importDefault(require("./billingDeterminants/MonthlyDemand"));
var AnnualDemand_1 = __importDefault(require("./billingDeterminants/AnnualDemand"));
var MonthlyEnergy_1 = __importDefault(require("./billingDeterminants/MonthlyEnergy"));
var SurchargeAsPercent_1 = __importDefault(require("./billingDeterminants/SurchargeAsPercent"));
var HourlyEnergy_1 = __importDefault(require("./billingDeterminants/HourlyEnergy"));
var DemandTiersInMonths_1 = __importDefault(require("./billingDeterminants/DemandTiersInMonths"));
var DemandTimeOfUse_1 = __importDefault(require("./billingDeterminants/DemandTimeOfUse"));
var DemandPerDay_1 = __importDefault(require("./billingDeterminants/DemandPerDay"));
var BillingDeterminantFactory = /** @class */ (function () {
    function BillingDeterminantFactory() {
    }
    BillingDeterminantFactory.make = function (type, _a, loadProfile) {
        var args = __rest(_a, []);
        switch (type) {
            case 'EnergyTimeOfUse':
                return new EnergyTimeOfUse_1.default(args, loadProfile);
            case 'BlockedTiersInDays':
                return new BlockedTiersInDays_1.default(args, loadProfile);
            case 'BlockedTiersInMonths':
                return new BlockedTiersInMonths_1.default(args, loadProfile);
            case 'FixedPerDay':
                return new FixedPerDay_1.default();
            case 'FixedPerMonth':
                return new FixedPerMonth_1.default();
            case 'MonthlyDemand':
                return new MonthlyDemand_1.default(loadProfile);
            case 'AnnualDemand':
                return new AnnualDemand_1.default(loadProfile);
            case 'MonthlyEnergy':
                return new MonthlyEnergy_1.default(loadProfile);
            case 'SurchargeAsPercent':
                return new SurchargeAsPercent_1.default(args);
            case 'HourlyEnergy':
                return new HourlyEnergy_1.default(args, loadProfile);
            case 'DemandTiersInMonths':
                return new DemandTiersInMonths_1.default(args, loadProfile);
            case 'DemandTimeOfUse':
                return new DemandTimeOfUse_1.default(args, loadProfile);
            case 'DemandPerDay':
                return new DemandPerDay_1.default(args, loadProfile);
        }
    };
    return BillingDeterminantFactory;
}());
exports.default = BillingDeterminantFactory;
